import AService from '@/services/AService'

const ENTITY_NAME = 'appointments';

export default class AppointmentService extends AService {
  async fetchById(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async getAll(params = {}) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/`, {params});
    return response.data;
  }

  async changeStatus(id, status){
    const params = {status: status};
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}/${id}/status`, params);
    return response.data;
  }

  async sendControlMail(id){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/send-control-mail/${id}`);
    return response.data;
  }
}
